import { formatNumber as formatNumberDefault } from 'accounting';
export function processValue(value, { emptyValue, precision, separators, range = {} }, formatNumber = formatNumberDefault) {
    let inputValue = cleanValue(value, separators);
    // Handle empty string
    if (inputValue === '' || inputValue === '-') {
        let clampedNumber = emptyValue;
        let clampedString = inputValue;
        if (clampedNumber === 0) {
            if (range.min && clampedNumber < range.min) {
                clampedNumber = range.min;
                clampedString = formatNumber(range.min, 0, '', separators.decimal);
            }
            else if (range.max && clampedNumber > range.max) {
                clampedNumber = range.max;
                clampedString = formatNumber(range.max, 0, '', separators.decimal);
            }
        }
        return {
            numberValue: clampedNumber,
            stringValue: clampedString,
        };
    }
    // Trim decimal places
    inputValue = trimDecimalPlace(inputValue, separators.decimal, formatNumber, precision);
    // Parse string to number and clamp
    const inputNumberValue = parseFloat(inputValue);
    const numberValue = clamp(inputNumberValue, range);
    // if not out of bound, use inputValue to preserve punctuation, otherwise use numberValue
    const stringValue = numberValue === inputNumberValue
        ? inputValue
        : formatNumber(numberValue, 0, '', separators.decimal);
    return {
        stringValue,
        numberValue: numberValue,
    };
}
function trimDecimalPlace(value, separator, formatNumber, precision) {
    const decimalPosition = value.indexOf(separator);
    if (decimalPosition >= 0) {
        if (precision) {
            const isNegative = value.startsWith('-');
            const splitValue = value.split(separator);
            const intPart = (isNegative ? '-' : '') + String(Math.abs(+splitValue[0]));
            let fracPart = splitValue[1];
            if (fracPart && fracPart.length > precision) {
                fracPart = fracPart.slice(0, precision);
            }
            return `${intPart}.${fracPart}`;
        }
        return value.substr(0, decimalPosition);
    }
    return String(+value);
}
function clamp(value, { min = -Infinity, max = Infinity }) {
    return Math.max(Math.min(value, max), min);
}
function cleanValue(value, separators) {
    const thousandsSeparatorRegEx = new RegExp(`[${separators.thousand}]{1,}`, 'g');
    const decimalSeparatorRegEx = new RegExp(`[${separators.decimal}+]{1,}`, 'g');
    const excessiveMinusSignRegEx = /(?!^)-/g;
    const cleanedValue = value
        // Remove invalid characters
        .replace(/[^0-9.,-]/g, '')
        // Remove thousand separators
        .replace(thousandsSeparatorRegEx, '')
        // Remove excessive decimal separators
        .replace(decimalSeparatorRegEx, separators.decimal)
        // Remove excessive minus signs
        .replace(excessiveMinusSignRegEx, '');
    return cleanedValue;
}
//# sourceMappingURL=process-value.js.map